import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

const DocumentsTableHead = ({ headerConfig }) => (
  <TableHead>
    <TableRow>
      {headerConfig.map(header => {
        return (
          <TableCell
            key={header.ref}
            style={{
              textAlign: header.ref === 'operations' ? 'center' : undefined,
            }}
          >
            {header.displayName}
          </TableCell>
        );
      })}
    </TableRow>
  </TableHead>
);

export default DocumentsTableHead;
